import React, {useContext} from 'react';
import {syncGoogleMerchantCenter} from '../../scripts/dataTable';
import {importExportContext} from '../../context/importExportContext';

const GSFButton = (props) => {
  const {setUploadStatus, setUploadSummary} = useContext(importExportContext);

  const callGSF = async () => {
    let gsfUrl = "/gsf/sync"
    gsfUrl += "?locale=" + props.storeLanguage + "_" + props.storeCountry;

    const {status} = await syncGoogleMerchantCenter(gsfUrl);
    console.log('STATUS: ', status);
    setUploadStatus(status);
    setUploadSummary(
        status ? [{type: "INFO", message: "Sync Successful."}]
            : [{
              type: "ERROR",
              message: "Sync failed. Please contact COM-TEAM (ece.ee.services.galileo@autodesk.com) for support."
            }]
    );
  }

  return (
      <div className={props.className}>
        <button className="pda-button-export" onClick={callGSF}>
          <div className="pda-float-left"> {props.buttonText} </div>
        </button>
      </div>
  )
}

export default GSFButton;


